import type SessionService from '@efdigital/ll-addon-auth/services/session';
import config from '@efdigital/ll-admin-v2/config/environment';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import logo from '../../assets/images/hult-ashridge-logo-white.svg';

interface FooterSignature {
  Element: HTMLDivElement;
}

const VERSION = config.APP.version as string;

export default class Footer extends Component<FooterSignature> {
  @service declare session: SessionService;

  logout = () => {
    return this.session.logout();
  };

  <template>
    <div class="text-bg-dark">
      <div class="container py-5">
        <div class="row">
          <div class="col-md-9 mb-3 mb-md-0">
            <ul class="list-unstyled">
              <li
                class="d-flex flex-row align-items-center justify-content-start flex-wrap gap-2"
              >
                {{#if this.session.cached.isAuthenticated}}
                  <span>
                    You are logged in as:
                    <strong>{{this.session.cached.displayName}}</strong>
                  </span>

                  <button
                    class="btn btn-sm btn-outline-white"
                    type="button"
                    {{on "click" this.logout}}
                  >Log Out</button>
                {{else}}
                  You are not logged in.
                {{/if}}
              </li>
              <li class="small">
                Application Version:
                {{VERSION}}
              </li>
            </ul>
            <p class="text-white">&copy; 2025 Hult Ashridge Executive Education.
              All rights reserved.</p>
          </div>
          <div class="col-md-3 align-self-end pb-4 d-flex flex-column">
            <img src={{logo}} class="img-fluid" alt="Hult Ashridge" />
          </div>
        </div>
      </div>
    </div>
  </template>
}
